let csrfToken = "";

export function setCsrf(token: string | undefined) {
  csrfToken = token ?? "";
}

export async function api<T>(path: string, init: RequestInit = {}) {
  const headers = new Headers(init.headers);
  if (csrfToken && !["GET", "HEAD"].includes(init.method ?? "GET")) headers.set("x-csrf-token", csrfToken);
  if (init.body && typeof init.body === "string" && !headers.has("content-type")) headers.set("content-type", "application/json");
  const response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  const contentType = response.headers.get("content-type") ?? "";
  const payload = contentType.includes("application/json") ? await response.json() : null;
  if (!response.ok) throw new Error((payload as { error?: string } | null)?.error ?? "Požadavek se nepodařilo dokončit.");
  return payload as T;
}

export function post<T>(path: string, body?: unknown) {
  return api<T>(path, { method: "POST", body: body === undefined ? undefined : JSON.stringify(body) });
}

export async function putJpeg(path: string, body: Blob) {
  const response = await fetch(path, {
    method: "PUT",
    body,
    credentials: "same-origin",
    headers: { "content-type": "image/jpeg", "x-csrf-token": csrfToken },
  });
  if (!response.ok) throw new Error("Fotografii se nepodařilo nahrát.");
}
